import axiosInstance from './axiosInstance';

export interface Note {
  id: number;
  userId: number;
  siteId: number;
  typeOfWorkId: number;
  text: string;
  closed: boolean;
  createdDate: string;
  userName?: string;
  siteName?: string;
  typeOfWorkName?: string;
  typeOfWorkSection?: string;
  site?: {
    id: number;
    name: string;
  };
  typeOfWork?: {
    id: number;
    name: string;
    section: string;
  };
  user?: {
    id: number;
    name: string;
  };
}

export interface CreateNoteRequest {
  site: {
    id: number;
  };
  typeOfWork: {
    id: number;
  };
  text: string;
}

export interface UpdateNoteRequest {
  text: string;
}

class NotesApi {
  async getAllNotes(): Promise<Note[]> {
    try {
      console.log('notesApi.getAllNotes: отправляем запрос на /Notes');
      const response = await axiosInstance.get<Note[]>('/Notes');
      console.log('notesApi.getAllNotes: получен ответ:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching all notes:', error);
      throw error;
    }
  }

  async getNote(id: number): Promise<Note> {
    try {
      const response = await axiosInstance.get<Note>(`/Notes/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching note:', error);
      throw error;
    }
  }

  async createNote(noteData: CreateNoteRequest): Promise<boolean> {
    try {
      console.log('notesApi.createNote: отправляем запрос на /Notes', noteData);
      const response = await axiosInstance.post<boolean>('/Notes', noteData);
      console.log('notesApi.createNote: получен ответ:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating note:', error);
      throw error;
    }
  }

  async updateNote(id: number, noteData: UpdateNoteRequest): Promise<void> {
    try {
      await axiosInstance.put(`/Notes/${id}`, noteData);
    } catch (error) {
      console.error('Error updating note:', error);
      throw error;
    }
  }

  async closeNote(id: number): Promise<void> {
    try {
      await axiosInstance.post(`/Notes/${id}/close`);
    } catch (error) {
      console.error('Error closing note:', error);
      throw error;
    }
  }

  async reopenNote(id: number): Promise<void> {
    try {
      await axiosInstance.post(`/Notes/${id}/reopen`);
    } catch (error) {
      console.error('Error reopening note:', error);
      throw error;
    }
  }

  async deleteNote(id: number): Promise<void> {
    try {
      await axiosInstance.delete(`/Notes/${id}`);
    } catch (error) {
      console.error('Error deleting note:', error);
      throw error;
    }
  }
}

export const notesApi = new NotesApi();
